import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServerError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 691,
	height: 673,
	viewBox: "0 0 691 673",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clippath",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 690,
			height: 672,
			style: { fill: "none" }
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_1-2",
		children: /* @__PURE__ */ _jsxs("g", {
			style: { clipPath: "url(#clippath)" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M374.6,542.3c123.7,0,223.9-100.2,223.9-223.9s-100.2-223.9-223.9-223.9-223.9,100.2-223.9,223.9,100.2,223.9,223.9,223.9Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M374.6,581.8c145.5,0,263.4-117.9,263.4-263.4S520.1,55.1,374.6,55.1,111.2,173,111.2,318.4s117.9,263.4,263.4,263.4h0Z",
					style: {
						fill: "none",
						stroke: "#f5faff",
						strokeMiterlimit: 10,
						strokeWidth: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M377.8,404.1c-17.3-18.3-37.1-30.8-58.5-30,22.4-.3,42.4,13.2,58.5,30Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M440.9,523c-2.8-12.5-9.9-32.5-20.3-53.8.6,1.3,1.1,2.5,1.6,3.7,10.2,24.5,16.1,40.1,18.6,50.1h.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M482.4,444.6c3.9,5.6,6.9,19.2,3,19.7-5,.8-7.9-6.6-13.8-6.3-6.6.3-6.4,16.6-16.1,18.1-10.5,1.6-7.9-14.1-15-22.1s-18.9-3.4-23.3-1c-.9,1.1-1.7,2.2-2.5,3.2,2,3.8,3.5,6.6,4.2,8,.2.4.4.7.6,1.1,0,0-.2-.3-.6-1.1-.8-1.4-1.7-2.7-2.6-4,1.6,3.1,3,6.1,4.3,8.9,10.3,21.4,17.4,41.4,20.2,53.9.8,2.8,1.3,5.7,1.4,8.6v.3c27.6-8.8,53.3-22.8,75.5-41.4l-.5-.5c-6-13.6-20.1-32.2-35-45.4h.2Z",
					style: {
						fill: "#b8daff",
						isolation: "isolate",
						opacity: .3
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M225.5,485.5c-.4.9-.6,1.6-.8,2.1.2-.5.4-1.2.8-2.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M308.2,415.8c-.3-.4-.5-.7-.8-1.1.3.4.6.7.8,1.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.5,413.8c-.4-.4-.9-.8-1.4-1.1.5.3,1,.7,1.4,1.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M309.4,417.7c-.4-.7-.7-1.3-1.2-1.9.4.6.8,1.2,1.2,1.9Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M310.8,420.7c-.4-.8-.7-1.6-1.1-2.3.4.7.7,1.5,1.1,2.3Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M295.5,415.3c-.5.4-1,.9-1.6,1.4.5-.5,1-1,1.6-1.4Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M313.1,426.7c-.2-.6-.4-1.2-.6-1.8.2.6.4,1.2.6,1.8Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M311.5,422.3c-.2-.6-.5-1.1-.7-1.6.2.5.5,1.1.7,1.6Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.9,429.5l-1.8,2.3,1.8-2.3Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M250.2,456.3c-.2-.7-.3-1.4-.4-2.1,0,.7.2,1.4.4,2.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M271.2,444.8c-1.7,2.3-3.5,4.4-5.1,6.3,1.6-1.9,3.4-4.1,5.1-6.3Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M249.9,454.2c-.1-1.2-.2-2.5-.2-3.7,0,1.2,0,2.5.2,3.7Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256.6,459.9c-.4.2-.8.4-1.2.5.4-.1.8-.3,1.2-.5Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M275.7,439c-.9,1.2-1.8,2.4-2.7,3.5.9-1.2,1.8-2.4,2.7-3.5Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M313.8,428.5l-.6-1.8.6,1.8Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M289,421.9c-.6.7-1.1,1.3-1.7,2,.6-.7,1.2-1.3,1.7-2Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M259.3,458.2c-.6.5-1.3,1-2,1.4.7-.4,1.4-.9,2-1.4Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.4,435.4l-1.8,2.4,1.8-2.4Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260.7,456.9c.7-.7,1.5-1.4,2.3-2.2-.8.8-1.5,1.6-2.3,2.2Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M353,438.8c-1.3.9-2.5,1.9-3.7,2.9,1.1-1,2.4-2,3.7-2.9Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M345.8,444.8c-.6.5-1.1,1-1.7,1.5.6-.5,1.1-1,1.7-1.5Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.5,413.8l.9.9-.9-.9Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M315,432.3l-.6-1.9.6,1.9Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M354.9,437.5c-.7.4-1.3.8-2,1.3.7-.5,1.3-.9,2-1.3Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.5,426.3c-11.3,18.9-21,38.7-29,59.2,41,36.7,94.1,56.9,149.1,56.9h1c.2-18.9,21-56.1,32.1-74.7-13.7-9.7-31.4-29.7-42.1-30-14.8-.3-17.8,42.3-36.4,35.9-19.2-6.7-17.6-67.7-30.6-56.5-23.6,20.6-38,80.7-51.7,60.6-6.5-9.4,2.6-41.5,5.6-45.9-2.9,4.4-12.1,36.5-5.6,45.9,13.8,20,28.1-40,51.7-60.6,12.9-11.3,11.4,49.8,30.6,56.5,18.5,6.4,21.6-36.2,36.4-35.9,10.7.3,28.4,20.3,42.1,30,2.9-4.9,5.2-8.5,6.2-10.1-1.5-2.1-3.1-4.1-4.8-6-13.8-14.2-32.8-21.6-48.8-16.5-1.2.4-2.3.8-3.4,1.4-.7.4-1.4.7-2.1,1.2-.7.4-1.3.8-2,1.3-1.3.9-2.5,1.9-3.7,2.9l-.9.8c-.9.8-1.7,1.5-2.6,2.3-.6.5-1.1,1-1.7,1.5-4.2,3.7-8.4,6.8-13.6,6.6-3.8-.1-6.7-2.4-9.1-5.9-.3-.5-.6-.9-.9-1.4-.9-1.6-1.7-3.2-2.4-4.9-.4-.9-.7-1.8-1.1-2.7l-.7-1.9c-.4-1.2-.9-2.5-1.3-3.8l-.6-1.9-.6-1.9-.6-1.8c-.2-.6-.4-1.2-.6-1.8-.3-.9-.7-1.8-1-2.6-.2-.6-.5-1.1-.7-1.6-.4-.8-.7-1.6-1.1-2.3-.1-.2-.2-.5-.4-.7-.4-.7-.7-1.3-1.2-1.9-.3-.4-.5-.7-.8-1.1l-.9-.9c-.4-.4-.9-.8-1.4-1.1-.8-.5-1.8-.7-2.7-.8-2,0-4.3,1.2-6.8,3.4-.5.4-1,.9-1.6,1.4-1.6,1.5-3.2,3.3-4.9,5.2-.6.7-1.2,1.3-1.7,2-1.5,1.7-2.9,3.6-4.4,5.5l-1.8,2.3-2.7,3.6-1.8,2.4-.9,1.2c-.9,1.2-1.8,2.4-2.7,3.5-.6.8-1.2,1.5-1.8,2.3-1.7,2.3-3.5,4.4-5.1,6.3-1.1,1.3-2.2,2.5-3.2,3.6-.8.8-1.5,1.6-2.3,2.2-.5.4-1,.9-1.4,1.2-.6.5-1.3,1-2,1.4-.2.1-.4.2-.6.3-.4.2-.8.4-1.2.5-.9.3-1.8.3-2.6-.1-1.2-.6-2.1-2-2.6-4-.2-.7-.3-1.4-.4-2.1-.1-1.2-.2-2.5-.2-3.7v-2.7c0-.9.1-1.9.2-2.8,0-.9.2-1.9.4-2.9.2-1.4.5-2.9.8-4.3.2-.9.4-1.8.6-2.7.2-.9.4-1.7.7-2.6.2-.8.4-1.6.7-2.3.2-.7.5-1.4.7-2s.5-1.2.7-1.7l.6-1.2c2.7-4.3,5.5-8.5,8.3-12.5-20.1,28.1-34.1,62.9-37.8,72.6,8.1-20.5,17.8-40.2,29.1-59.1h0Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.1,451.4c1.7,1.9,3.4,3.9,4.9,6l.2-.3c-1.6-2-3.2-3.9-5-5.7h-.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M357,436.3c-.7.4-1.4.7-2.1,1.2.7-.5,1.4-.8,2.1-1.2Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M348.4,442.4c-.9.8-1.7,1.5-2.6,2.3.9-.8,1.7-1.6,2.6-2.3Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M319,374.1h-1.3c-6.2,0-12.2,1.4-17.7,4.1,5.5-2.4,11.3-3.7,17.3-4,.6,0,1.2-.1,1.7-.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M318.1,440.6c-.4-.9-.7-1.8-1.1-2.7.4.9.7,1.8,1.1,2.7Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M321.4,447c-.3-.5-.6-.9-.9-1.4.3.5.6,1,.9,1.4Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M317,438l-.7-1.9.7,1.9Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415.7,459.2c-.5-.7-1-1.4-1.5-2l-.2.3c1.4,1.9,2.6,3.9,3.9,5.9-.7-1.4-1.4-2.8-2.2-4.2h0Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M442.3,530.7c-.3-2.6-.7-5.2-1.3-7.7-2.5-10-8.5-25.6-18.6-50.1-.5-1.2-1-2.4-1.6-3.7-.9-1.9-1.9-3.8-2.9-5.8-1.2-2.1-2.5-4-3.9-5.9-1,1.6-3.3,5.2-6.2,10.1,5.3,3.7,9.9,6,13.4,4.9-3.4,1-8.1-1.2-13.4-4.9-11.1,18.6-31.9,55.8-32.1,74.7,22.7,0,45.2-3.6,66.8-10.4v-1.2h-.2Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M442.4,531.6c-.2-2.9-.6-5.8-1.4-8.6.6,2.5,1.1,5.1,1.3,7.7v.9h.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.8,463.4h0c1,1.9,1.9,3.9,2.9,5.8-1.3-2.8-2.7-5.8-4.3-8.9l-.7-1.1c.7,1.4,1.5,2.8,2.2,4.2h-.1Z",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.9,393.6c-5.7,6-10.9,12.4-15.5,19.3,4.6-6.6,9.7-12.8,15.3-18.6,0-.3.1-.5.2-.7h0Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M365.2,394.5c16.7,13.7,31.4,32.4,42.3,50-8.6-14.6-18.6-28.7-29.7-40.4-16.1-16.8-36.1-30.3-58.5-30,19.6,0,39.4,13.1,43,16.4,1.2,1.2,2.2,2.6,2.9,4.1v-.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M300,378.2c-2.1.9-4.2,2-6.2,3.2.7-.4,1.4-.7,2.1-1,1.4-.8,2.8-1.6,4.1-2.2Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.5,456.6s0-.1.1-.2l.2-.2c-6.6-12.1-19.5-34-36.9-52.1,11.1,11.7,21.1,25.9,29.7,40.4,2.5,4.1,4.9,8.1,7,12l-.1.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.5,456.6c.7,1.2,1.3,2.4,1.9,3.6.9,1.3,1.8,2.7,2.6,4-.8-1.4-2.2-4.2-4.2-8l-.2.2s0,.1-.1.2h0Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M419.6,465.3c-.2-.4-.4-.7-.6-1.1.4.7.6,1.1.6,1.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M249.8,447.9c0-.9.1-1.9.2-2.8-.1,1-.2,1.9-.2,2.8Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M360.3,434.9c16-5.1,34.9,2.3,48.8,16.5-13.5-14.9-32.1-21.8-48.8-16.5Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M317.3,374.2c-5.9.3-11.8,1.6-17.3,4-1.4.7-2.7,1.4-4.1,2.2,6.9-3.2,14.7-5.7,21.4-6.2Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.5,444.6c2.4,4,4.7,8.1,6.9,12.2v-.2c-2-3.9-4.3-7.9-6.9-12Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.4,456.8c-2.2-4.1-4.5-8.2-6.9-12.2-10.9-17.6-25.6-36.3-42.3-50,2.2,4.2,3.6,10.4,1.3,15.9-5.3,12.8-17.9,10-30.4-5.1-13.7-16.4-20.5-19.2-31.5-7.2-14.9,16.3-27.8,5.1-26.1-3.6-8.4,8.5-16.1,19.1-23.5,30.8l-.6,1.2c-.2.5-.5,1-.7,1.7s-.5,1.3-.7,2-.4,1.5-.7,2.3c-.2.8-.4,1.7-.7,2.6-.2.9-.4,1.8-.6,2.7-.3,1.4-.5,2.8-.8,4.3-.1,1-.3,1.9-.4,2.9s-.2,1.9-.2,2.8v2.7c0,1.2,0,2.5.2,3.7,0,.7.2,1.4.4,2.1.5,1.9,1.3,3.4,2.6,4,.8.4,1.8.4,2.6.1.4-.1.8-.3,1.2-.5.2-.1.4-.2.6-.3.7-.4,1.4-.9,2-1.4.5-.4,1-.8,1.4-1.2.7-.7,1.5-1.4,2.3-2.2,1-1.1,2.1-2.3,3.2-3.6,1.6-1.9,3.4-4.1,5.1-6.3.6-.8,1.2-1.5,1.8-2.3.9-1.2,1.8-2.3,2.7-3.5l.9-1.2,1.8-2.4,2.7-3.6,1.8-2.3c1.5-1.9,3-3.8,4.4-5.5.6-.7,1.1-1.4,1.7-2,1.7-2,3.4-3.8,5-5.2.5-.5,1-1,1.6-1.4,2.5-2.1,4.9-3.4,6.8-3.4,1,0,1.9.3,2.7.8.5.3,1,.7,1.4,1.1l.9.9c.3.4.6.7.8,1.1.4.6.8,1.2,1.2,1.9.1.2.2.5.4.7.4.7.7,1.5,1.1,2.3.2.5.5,1.1.7,1.6.3.8.7,1.7,1,2.6.2.6.4,1.2.6,1.8l.6,1.9.6,1.9.6,1.9c.4,1.3.9,2.5,1.3,3.8l.7,1.8c.4.9.7,1.8,1.1,2.7.7,1.7,1.5,3.3,2.4,4.9.3.5.6,1,.9,1.4,2.3,3.4,5.2,5.7,9,5.9,5.3.2,9.4-2.9,13.6-6.6.6-.5,1.1-1,1.7-1.5.9-.8,1.7-1.5,2.6-2.3l.9-.8c1.2-1,2.4-2,3.7-2.9.6-.5,1.3-.9,2-1.3s1.4-.8,2.1-1.1c1.1-.5,2.2-1,3.3-1.4,16.6-5.3,35.3,1.6,48.8,16.5,1.8,1.8,3.4,3.7,5,5.7l.2-.4.1-.3Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M250.4,442.2c.2-1.4.5-2.9.8-4.3-.3,1.4-.5,2.8-.8,4.3Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M252.4,432.6c.2-.8.4-1.6.7-2.3-.2.7-.4,1.5-.7,2.3Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M251.1,437.9c.2-.9.4-1.8.6-2.7-.2.9-.4,1.8-.6,2.7Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.6,394.6v-.3c-5.6,5.8-10.7,12-15.3,18.6-2.8,4-5.5,8.2-8.3,12.5,7.4-11.7,15.1-22.3,23.5-30.8h.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M253,430.3c.2-.7.5-1.4.7-2-.2.6-.4,1.3-.7,2Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M253.7,428.2c.2-.6.4-1.2.7-1.7-.2.5-.4,1-.7,1.7Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.1,457.2c.5.7,1,1.3,1.5,2-.4-.8-.9-1.6-1.3-2.4l-.2.4Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.4,456.8c.4.8.9,1.6,1.3,2.4l.7,1.1c-.6-1.2-1.2-2.4-1.9-3.6v.2l-.1-.1Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M293.8,381.4c-7.5,3.8-13.5,8.4-14.9,11.7,0,.1,0,.3-.1.4,4.4-4.7,9.5-8.8,15-12.1Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M295.9,380.4c-.7.3-1.4.7-2.1,1-5.5,3.4-10.6,7.5-15,12.1,0,.2-.1.5-.2.7,5.1-5.4,10.9-10,17.3-13.8h0Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M365.2,394.5c-.7-1.5-1.7-2.9-2.9-4.1-3.6-3.3-23.4-16.4-43-16.4h-.2c16.1.6,31.8,8.7,46.1,20.4v.1Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M319,374.1h-1.7c-6.7.4-14.5,3-21.4,6.2-6.4,3.8-12.2,8.5-17.3,13.9v.3c11.9-12,25.1-19.9,40.5-20.5h0l-.1.1Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.6,394.6c-1.8,8.7,11.1,19.9,26.1,3.6,11-12,17.8-9.2,31.5,7.2,12.5,15.1,25.1,17.9,30.4,5.1,2.3-5.5.9-11.7-1.3-15.9-14.3-11.7-30-19.8-46.1-20.4-15.4.6-28.6,8.4-40.5,20.5l-.1-.1Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M449.6,428.4c9-1.3,21.1,5.8,32.8,16.2-.4-.6-. 8-1.1-1.4-1.6-20.2-17.5-37.6-25.5-63.7,10.1,7-9.1,17.7-22.5,32.3-24.7h0Z",
					style: {
						fill: "#f5faff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M440.5,454.1c7.1,8,4.5,23.6,15,22.1,9.6-1.5,9.5-17.8,16.1-18.1,5.9-.3,8.8,7.1,13.8,6.3,3.9-.6.9-14.1-3-19.7-11.7-10.4-23.8-17.5-32.8-16.2-14.7,2.1-25.4,15.6-32.4,24.6,4.4-2.4,16.2-7,23.3,1h0Z",
					style: {
						fill: "#f5faff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M419.6,465.3c-.4.8-42-92-100.4-91.2-28.2.4-46.4,23.1-64.2,51.3-3.3,5.3-8.9,31.7-2.3,34.9,10,4.8,37-48.7,49.6-48.4,12.6.4,11.8,40.4,28.1,40.9,11.3.4,17.4-14,29.9-17.9,20.6-6.6,46.1,7.6,59.3,30.4h0Z",
					style: { fill: "#e7f3ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M252.6,431.7c-3,4.4-12.1,36.5-5.6,45.9,13.8,20,28.1-40,51.7-60.6,12.9-11.3,11.4,49.8,30.6,56.5,18.5,6.4,21.6-36.2,36.4-35.9,14.8.4,43.1,38.7,55.4,34.9",
					style: {
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeMiterlimit: 10,
						strokeWidth: ".8px"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M319.3,374.1c-15,0-36.3,13.6-39.1,20.5-3.6,8.8,8.7,20.8,24.4,3.6,11-12,17.8-9.2,31.5,7.2,12.5,15.1,25.1,17.9,30.4,5.1,3.3-7.8-1-17.1-4.2-20-3.6-3.2-23.4-16.3-43-16.3v-.1Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M224.8,487.5c8.2-21.2,18.1-41.7,29.8-61.2",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.6,456.5c6.9-8.6,18.4-25.6,35-28,20.4-3,56.9,37.3,67.8,61.5",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.2,453.1c4.4-2.4,16.2-7,23.3,1,7.1,8,4.5,23.6,15,22.1,9.6-1.5,9.5-17.8,16.1-18.1,5.9-.3,8.8,7.1,13.8,6.3,4.4-.6,0-17.5-4.4-21.4-20.2-17.5-37.6-25.5-63.7,10.1",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.2,453.1c4.4-2.4,16.2-7,23.3,1,7.1,8,4.5,23.6,15,22.1,9.6-1.5,9.5-17.8,16.1-18.1,5.9-.3,8.8,7.1,13.8,6.3,4.4-.6,0-17.5-4.4-21.4-20.2-17.5-37.6-25.5-63.7,10.1",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M442.5,531.8s-.1,1-.3-1.1c-2.4-28.2-55.2-159-123-156.6-26.4.9-46.4,23.1-64.2,51.3-3.3,5.3-8.9,31.7-2.3,34.9,10,4.8,37-48.7,49.6-48.4,12.6.4,11.8,40.4,28.1,40.9,11.3.4,17.4-14,29.9-17.9,20.6-6.6,44.3,5.6,57.5,28.5",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M541.8,142.3c5.8,0,11.4-1.7,16.2-4.9s8.5-7.8,10.7-13.1c2.2-5.3,2.8-11.2,1.7-16.9-1.1-5.7-3.9-10.9-8-14.9-4.1-4.1-9.3-6.9-15-8s-11.5-.5-16.9,1.7c-5.3,2.2-9.9,6-13.1,10.8-3.2,4.8-4.9,10.4-4.9,16.2s.8,7.6,2.2,11.2c1.5,3.5,3.6,6.8,6.3,9.5s5.9,4.9,9.5,6.3c3.5,1.5,7.3,2.2,11.2,2.2l.1-.1Z",
					style: {
						fill: "none",
						stroke: "#e7f3ff",
						strokeMiterlimit: 10,
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M584.2,609c3.5-3.5,5.9-8,6.8-12.8,1-4.9.5-9.9-1.4-14.5s-5.1-8.5-9.2-11.2c-4.1-2.8-9-4.2-13.9-4.2s-9.8,1.5-13.9,4.2c-4.1,2.8-7.3,6.7-9.2,11.2-1.9,4.6-2.4,9.6-1.4,14.5s3.3,9.3,6.8,12.8c2.3,2.3,5.1,4.2,8.1,5.4,3,1.3,6.3,1.9,9.6,1.9s6.6-.7,9.6-1.9c3-1.3,5.8-3.1,8.1-5.4h0Z",
					style: { fill: "#e2f0ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M590.2,615c4.7-4.7,7.9-10.7,9.2-17.2s.6-13.3-1.9-19.4-6.8-11.4-12.4-15.1c-5.5-3.7-12-5.7-18.6-5.7s-13.1,2-18.6,5.7-9.8,8.9-12.4,15.1c-2.5,6.1-3.2,12.9-1.9,19.4s4.5,12.5,9.2,17.2c3.1,3.1,6.8,5.6,10.9,7.3,4.1,1.7,8.4,2.6,12.9,2.6s8.8-.9,12.9-2.6c4.1-1.7,7.8-4.2,10.9-7.3h-.2Z",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.4,37.3c1.3-1.3,2.1-2.9,2.4-4.6.3-1.7.2-3.6-.5-5.2s-1.8-3-3.3-4-3.2-1.5-5-1.5-3.5.5-5,1.5-2.6,2.4-3.3,4-.9,3.4-.5,5.2c.3,1.7,1.2,3.3,2.4,4.6.8.8,1.8,1.5,2.9,2,1.1.5,2.3.7,3.5.7s2.4-.2,3.5-.7,2.1-1.1,2.9-2h0Z",
					style: { fill: "#e2f0ff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.6,39.5c1.7-1.7,2.8-3.8,3.3-6.2.5-2.3.2-4.8-.7-7s-2.5-4.1-4.4-5.4c-2-1.3-4.3-2-6.7-2s-4.7.7-6.7,2-3.5,3.2-4.4,5.4c-.9,2.2-1.2,4.6-.7,7,.5,2.3,1.6,4.5,3.3,6.2,1.1,1.1,2.5,2,3.9,2.6,1.5.6,3,.9,4.6.9s3.2-.3,4.6-.9c1.5-.6,2.8-1.5,3.9-2.6h0Z",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeMiterlimit: 10,
						strokeWidth: 2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M144.5,106.6c2.4-2.4,4.1-5.5,4.7-8.8.7-3.3.3-6.8-1-10s-3.5-5.8-6.4-7.7c-2.8-1.9-6.2-2.9-9.6-2.9s-6.8,1-9.6,2.9c-2.8,1.9-5.1,4.6-6.4,7.7-1.3,3.2-1.7,6.6-1,10,.7,3.3,2.3,6.4,4.7,8.8,3.2,3.2,7.6,5.1,12.2,5.1s9-1.8,12.2-5.1h.2Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.7,110.7c4.3-4.3,6.8-10.2,6.8-16.4s-2.4-12-6.8-16.4c-10.5-8.7-26-8.5-32.7,0-2.2,2.1-3.9,4.7-5.1,7.5s-1.8,5.8-1.8,8.9.6,6.1,1.7,8.9c1.2,2.8,2.9,5.4,5,7.6,2.2,2.2,4.7,3.9,7.6,5,2.8,1.2,5.9,1.8,8.9,1.7,3.1,0,6.1-.6,8.9-1.8,2.8-1.2,5.4-2.9,7.5-5.1h0v.1Z",
					style: {
						fill: "none",
						isolation: "isolate",
						opacity: .6,
						stroke: "#e2f0ff",
						strokeMiterlimit: 10,
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M495.7,648.5l-5.4,21.5",
					style: {
						fill: "none",
						stroke: "#cfe6ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M482.3,656.5l21.2,5.5",
					style: {
						fill: "none",
						stroke: "#cfe6ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M617.5,55.1l-14.5,20.7",
					style: {
						fill: "none",
						stroke: "#b8daff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M600.1,58.1l20.4,14.6",
					style: {
						fill: "none",
						stroke: "#b8daff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M500.3,8.2l-13.9,1.3",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M492.7,2l1.2,13.7",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.9,477.1l-3.9,15.3",
					style: {
						fill: "none",
						stroke: "#cfe6ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.4,482.8l15.1,3.9",
					style: {
						fill: "none",
						stroke: "#cfe6ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.9,134.9l-13.9,1.3",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.3,128.6l1.2,13.7",
					style: {
						fill: "none",
						stroke: "#e2f0ff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M280.2,148.4h-73.7c-8.2,0-14.8,6.6-14.8,14.8s6.6,14.8,14.8,14.8h73.7c8.2,0,14.8-6.6,14.8-14.8s-6.6-14.8-14.8-14.8Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M254.9,168.5c16.1,0,29.1-13,29.1-29.1s-13-29.1-29.1-29.1-29.1,13-29.1,29.1,13,29.1,29.1,29.1Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.4,159.2c8.4,0,15.2-6.8,15.2-15.2s-6.8-15.2-15.2-15.2-15.2,6.8-15.2,15.2,6.8,15.2,15.2,15.2Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.3,145.2c5.3,0,9.7-4.3,9.7-9.7s-4.3-9.7-9.7-9.7-9.7,4.3-9.7,9.7,4.3,9.7,9.7,9.7Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M651.7,296.9h-85c-9.4,0-17,7.6-17,17s7.6,17,17,17h85c9.4,0,17-7.6,17-17s-7.6-17-17-17Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M622.6,320.1c18.5,0,33.5-15,33.5-33.5s-15-33.5-33.5-33.5-33.5,15-33.5,33.5,15,33.5,33.5,33.5Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M581.6,309.4c9.7,0,17.5-7.8,17.5-17.5s-7.8-17.5-17.5-17.5-17.5,7.8-17.5,17.5,7.8,17.5,17.5,17.5Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M678.3,293.2c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2-11.2,5-11.2,11.2,5,11.2,11.2,11.2Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M138.4,253h-61.5c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h61.5c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3h0Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.3,269.8c13.4,0,24.3-10.9,24.3-24.3s-10.9-24.3-24.3-24.3-24.3,10.9-24.3,24.3,10.9,24.3,24.3,24.3Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.7,262c7,0,12.7-5.7,12.7-12.7s-5.7-12.7-12.7-12.7-12.7,5.7-12.7,12.7,5.7,12.7,12.7,12.7Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M141.5,253c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1-8.1,3.6-8.1,8.1,3.6,8.1,8.1,8.1Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M54.8,246.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3-5.3,2.4-5.3,5.3,2.4,5.3,5.3,5.3Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.8,509.3h-103.5c-7.7,0-13.9,6.2-13.9,13.9s6.2,13.9,13.9,13.9h103.5c7.7,0,13.9-6.2,13.9-13.9s-6.2-13.9-13.9-13.9h0Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.9,525.1c18.6,0,33.8-15.1,33.8-33.8s-15.1-33.8-33.8-33.8-33.8,15.1-33.8,33.8,15.1,33.8,33.8,33.8Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.9,531.9c12.5,0,22.6-10.1,22.6-22.6s-10.1-22.6-22.6-22.6-22.6,10.1-22.6,22.6,10.1,22.6,22.6,22.6Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.8,499.6c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3-12.3,5.5-12.3,12.3,5.5,12.3,12.3,12.3Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#b8daff",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M227.6,281.9s-9.9,30.3-13.1,32c-2.1,1.1-16.8,7.5-26,11.5-2.2.9-4.1,2.4-5.4,4.3-1.3,1.9-2.1,4.2-2.2,6.5v35.1c0,3.7,3.3,6.7,7.4,6.8,3.7,0,7.5,0,7.5-.3,0-.8.7-21.7,24.3-21.8,22.4-.2,21.6,20.8,21.6,20.8h32.6l-.4-107.2c0-.7-.3-1.4-.8-1.9s-1.1-.8-1.8-.9c-9.1-.9-39.2-2.7-43.8,15l.1.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.6,280.1h27c.8,0,1.5.3,2.1.9.5.5.9,1.3.9,2.1v25.5c0,.7-.3,1.3-.8,1.8s-1.2.7-1.9.7h-37.1c-.3,0-.6,0-.9-.2-.3-.1-.5-.3-.7-.6-.2-.2-.3-.5-.4-.8v-.9l9-26.4c.2-.6.6-1.1,1-1.4.5-.4,1.1-.5,1.7-.6l.1-.1Z",
					style: {
						fill: "#e2f0ff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M247.6,310.6h-8l9-30.5h8l-9,30.5Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M253.7,310.6h-3.2l9-30.5h3.2l-9,30.5h0Z",
					style: { fill: "#f5faff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.6,280.1h27c.8,0,1.5.3,2.1.9.5.5.9,1.3.9,2.1v25.5c0,.7-.3,1.3-.8,1.8s-1.2.7-1.9.7h-37.1c-.3,0-.6,0-.9-.2-.3-.1-.5-.3-.7-.6-.2-.2-.3-.5-.4-.8v-.9l9-26.4c.2-.6.6-1.1,1-1.4.5-.4,1.1-.5,1.7-.6h0l.1-.1Z",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M274.3,376.5h153.6c.7,0,1.3-.4,1.8-.9s.7-1.2.7-1.9c.6-6.4,1.4-14.7,12.8-17.6h.3c2.2,0,25.6,0,24.2,0,0,0,4.1-2.6,9.8,15.1.8,2.5,2.1,4.7,4.3,4.7h24.1c.4,0,.7-.3,1-.6.2-.3.4-.7.3-1.1v-171.7c0-.8-.2-1.6-.7-2.2-.5-.6-1.2-1-2-1.1h-219c-5.3,0-12.2,2.5-11.8,13.4s.6,163.3.6,163.3",
					style: { fill: "#f3f6fc" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M274.3,376.5h153.6c.7,0,1.3-.4,1.8-.9s.7-1.2.7-1.9c.6-6.4,1.4-14.7,12.8-17.6h.3c2.2,0,25.6,0,24.2,0,0,0,4.1-2.6,9.8,15.1.8,2.5,2.1,4.7,4.3,4.7h24.1c.4,0,. 7-.3,1-.6.2-.3.4-.7.3-1.1v-171.7c0-.8-.2-1.6-.7-2.2-.5-.6-1.2-1-2-1.1h-219c-5.3,0-12.2,2.5-11.8,13.4s.6,163.3.6,163.3",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.1,358.9h-117.5v9.3h157.1s3.2-7.1,6-9.4h-24.2",
					style: { fill: "#b8daff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.1,358.9h-117.5v9.3h157.1s3.2-7.1,6-9.4h-24.2",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M401.1,358.9h-4.9",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M514.9,362.6v2.3c-.1.9-.5,1.7-1.1,2.4-.6.6-1.5,1-2.4,1h-33.9s-2.3-6.8-6.3-9.5l40.2.2c.5,0,1,0,1.4.3.4.2.8.5,1.2.8.3.3.6.8.8,1.2.2.4.2.9.2,1.4l-.1-.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M235.4,378.4h-56.9c-2,0-3.8-2-4.5-5l-1.3-6c-.7-3.2,1.8-6.5,4-6.5h58.8v17.5h-.1Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M263.9,368.9h5.3",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.4,368.9h19",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.9,356.9h13.8",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M270.4,379.4h-36",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.4,397.3c13.1,0,23.8-10.6,23.8-23.8s-10.6-23.8-23.8-23.8-23.8,10.6-23.8,23.8,10.6,23.8,23.8,23.8Z",
					style: {
						fill: "#9fcdff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.4,387.2c7.6,0,13.7-6.1,13.7-13.7s-6.1-13.7-13.7-13.7-13.7,6.1-13.7,13.7,6.1,13.7,13.7,13.7Z",
					style: {
						fill: "#e2f0ff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.4,384.5c6.1,0,11-4.9,11-11s-4.9-11-11-11-11,4.9-11,11,4.9,11,11,11Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.4,378.4c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9-4.9,2.2-4.9,4.9,2.2,4.9,4.9,4.9Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.5,397.6c13.1,0,23.8-10.6,23.8-23.8s-10.6-23.8-23.8-23.8-23.8,10.6-23.8,23.8,10.6,23.8,23.8,23.8Z",
					style: {
						fill: "#9fcdff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.5,387.6c7.6,0,13.7-6.1,13.7-13.7s-6.1-13.7-13.7-13.7-13.7,6.1-13.7,13.7,6.1,13.7,13.7,13.7Z",
					style: {
						fill: "#e2f0ff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.5,384.9c6.1,0,11-4.9,11-11s-4.9-11-11-11-11,4.9-11,11,4.9,11,11,11Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.5,378.8c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9-4.9,2.2-4.9,4.9,2.2,4.9,4.9,4.9Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.8,277.3h29.6c.6,0,1.3.1,1.8.4.6.2,1.1.6,1.6,1,.4.4.8,1,1,1.6s.4,1.2.4,1.8v71.9c0,.6-.1,1.3-.4,1.8s-.6,1.1-1,1.6c-.4.4-1,.8-1.6,1s-1.2.4-1.8.4h-25.7c-5.6-9.7-14.1-11.8-18-12.2-.6,0-1.2-.4-1.6-.8s-.6-1.1-.6-1.7v-28.3c0-1.3.2-2.6.7-3.9l11.1-31.4c.3-.9.9-1.7,1.7-2.3.8-.6,1.8-.9,2.7-.9h.1Z",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M229.6,295.5h-.7c-2.3,0-4.1,1.8-4.1,4.1v7.3c0,2.3,1.8,4.1,4.1,4.1h.7c2.3,0,4.1-1.8,4.1-4.1v-7.3c0-2.3-1.8-4.1-4.1-4.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M210.3,331.4h-23.5",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M265.8,328.5h0c-1,0-1.9.8-1.9,1.9v7.8c0,1,.8,1.9,1.9,1.9h0c1,0,1.9-.8,1.9-1.9v-7.8c0-1-.8-1.9-1.9-1.9Z",
					style: {
						fill: "#9fcdff",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.4,334.6h-28.7",
					style: {
						fill: "none",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M185.1,330.8h-2.7c-2.5,0-4.4,2-4.4,4.5v13.8c0,2.5,2,4.5,4.4,4.5h2.7c2.5,0,4.4-2,4.4-4.5v-13.8c0-2.5-2-4.5-4.4-4.5Z",
					style: {
						fill: "#e7f3ff",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M508.6,336.8h-2.7c-2.5,0-4.5,2-4.5,4.4v7.8c0,2.5,2,4.5,4.5,4.5h2.7c2.5,0,4.5-2,4.5-4.5v-7.8c0-2.5-2-4.4-4.5-4.4h0Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M327.4,314.9c-4.7,0-8.9-.9-12.6-2.6s-6.6-4.1-8.8-7.2c-2.2-3-3.3-6.5-3.4-10.5h14c.2,2.6,1.3,4.8,3.3,6.4s4.5,2.5,7.4,2.5,4.3-.5,6-1.5,3.1-2.4,4.1-4.2c1-1.8,1.5-3.9,1.5-6.3s-.5-4.5-1.5-6.3-2.4-3.2-4.2-4.3c-1.8-1-3.8-1.5-6.1-1.6-2,0-3.9.4-5.8,1.2-1.9.8-3.3,1.9-4.4,3.4l-12.9-2.3,3.2-36.1h41.8v11.8h-29.9l-1.8,17.1h.4c1.2-1.7,3-3.1,5.4-4.2s5.1-1.7,8.1-1.7,7.8,1,11,2.9,5.8,4.6,7.6,8,2.8,7.2,2.8,11.6-1,8.7-3.2,12.3-5.1,6.4-9,8.4-8.3,3.1-13.4,3.1l.4.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.8,315.5c-5.7,0-10.7-1.4-14.8-4.2-4.1-2.8-7.3-6.9-9.5-12.2-2.2-5.3-3.3-11.7-3.3-19.2s1.1-13.8,3.3-19.1c2.2-5.3,5.4-9.3,9.5-12s9.1-4.1,14.8-4.1,10.6,1.4,14.8,4.1c4.1,2.8,7.3,6.8,9.5,12,2.2,5.2,3.3,11.6,3.3,19s-1.1,13.9-3.3,19.2c-2.2,5.3-5.4,9.4-9.5,12.2-4.1,2.8-9,4.2-14.8,4.2v.1ZM389.8,303.5c3.9,0,7-2,9.4-5.9,2.3-3.9,3.5-9.8,3.5-17.7,0-5.2-.5-9.5-1.6-13-1.1-3.4-2.5-6-4.5-7.8-1.9-1.7-4.2-2.6-6.8-2.6-3.9,0-7,1.9-9.3,5.8s-3.5,9.7-3.5,17.5c0,5.3.5,9.6,1.6,13.1s2.6,6.1,4.5,7.9c1.9,1.7,4.2,2.6,6.8,2.6l-.1.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.5,315.5c-5.7,0-10.7-1.4-14.8-4.2-4.1-2.8-7.3-6.9-9.5-12.2-2.2-5.3-3.3-11.7-3.3-19.2s1.1-13.8,3.3-19.1c2.2-5.3,5.4-9.3,9.5-12s9.1-4.1,14.8-4.1,10.6,1.4,14.8,4.1c4.1,2.8,7.3,6.8,9.5,12,2.2,5.2,3.3,11.6,3.3,19s-1.1,13.9-3.3,19.2c-2.2,5.3-5.4,9.4-9.5,12.2-4.1,2.8-9,4.2-14.8,4.2v.1ZM454.5,303.5c3.9,0,7-2,9.4-5.9,2.3-3.9,3.5-9.8,3.5-17.7,0-5.2-.5-9.5-1.6-13-1.1-3.4-2.5-6-4.5-7.8-1.9-1.7-4.2-2.6-6.8-2.6-3.9,0-7,1.9-9.3,5.8s-3.5,9.7-3.5,17.5c0,5.3.5,9.6,1.6,13.1s2.6,6.1,4.5,7.9c1.9,1.7,4.2,2.6,6.8,2.6l-.1.1Z",
					style: {
						fill: "#b8daff",
						stroke: "#04264b",
						strokeMiterlimit: 10
					}
				})
			]
		})
	})]
});
export default SvgServerError;
